import { stripeClient } from "@better-auth/stripe/client";
import { adminClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
	baseURL: import.meta.env.VITE_BETTER_AUTH_URL || "http://localhost:3000",
	fetchOptions: {
		credentials: "include",
	},
	plugins: [stripeClient({ subscription: true }), adminClient()],
});

export const { signIn, signUp, signOut, useSession } = authClient;
